export default {
    peronInfoTitle: "完善个人信息,让BOSS快速了解你",
    skip: "跳过",
    pleaseEnter: "请输入",
    pleaseSelect: "请选择",
    continue: "下一步",
    name: "姓名",
    namePlaceholder: "请输入个人姓名 ",
    gender: "性别",
    male: "男",
    female: "女",
    dateOfBirth: "出生日期",
    startWorkingDate: "参加工作时间",
    jobStatus: "求职状态",
    personInfoCommitWarring: "请完善个人信息",
    jobIntentionTitle: "完善求职期望，增强简历竞争力",
    jobType: "求职类型",
    preferredPosition: "期望职位",
    preferredCity: "期望城市",
    preferredSalary: "期望薪资",
    jobIntentionCommitWarring: "请完善求职期望",
    educationTitle: "完善学历信息,吸引优质BOSS",
    school: "毕业高校",
    highestDegree: "最高学历",
    major: "专业",
    studyPeriod: "在校时间",
    timeWarring: "开始时间必须小于结束时间",
    educationCommitWarring: "请完善学历信息",
    step1: '第一步',
    step2: '第二步',
    step3: '第三步',
    save: '保存',
    saveAndContinue: '保存，下一步',
    savedSuccessfully: '保存成功',
    startTime: "开始时间",
    endTime: "结束时间",
    schoolName: "学校名称",
    cityNotFound: "没有该城市",
};
